import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/novels";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-500">
                po18
              </span>
              <span className="text-sm font-body text-foreground-700 ml-1">
                脸红心跳
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                首页
              </Link>
              <Link
                to="/category/全部"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/category/甜宠"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                甜宠小说
              </Link>
              <Link
                to="/category/虐恋"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                虐恋小说
              </Link>
              <Link
                to="/category/霸道总裁"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                霸总小说
              </Link>
              <Link
                to="/category/穿书"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                穿书小说
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-foreground-600 mb-2">
              邮箱：{siteInfo.email}
            </p>
            <p className="text-sm text-foreground-600">
              汇聚{siteInfo.novelCount}本精选小说<br />
              服务{siteInfo.readerCount}位读者
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} - 版权所有 |
            言情小说推荐与阅读指南
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}